import React, { useEffect, useState } from 'react'
import 'react-multi-carousel/lib/styles.css';
import Carousel from 'react-multi-carousel';
import { useAlert } from "react-alert";

export default function DownImages() {
    let alert = useAlert();
    const [files, setFiles] = useState([]);

    useEffect(() => {
        getLowerBanner()
    }, [])
    const responsive = {
        superLargeDesktop: {
            // the naming can be any, depends on you.
            breakpoint: { max: 4000, min: 3000 },
            items: 1
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 1
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 1
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1
        }
    };

    const getLowerBanner = (date) => {
        fetch(
            `${process.env.REACT_APP_URL_API}/data/getLowerBanner`,
            {
                method: "GET",
                mode: "cors",
                headers: {
                    "Content-Type": "application/json",
                    "Cache-Control": "no-cache",
                    "Access-Control-Allow-Origin": "*",
                },
            }
        )
            .then((response) => response.json())
            .then((data) => {
                var bannerpush = []
                data.map(banner => {
                    bannerpush.push({
                        id: banner.idlowerbanner,
                        link: banner.link,
                        file: banner.routeimage
                    })
                });

                setFiles(bannerpush);
            })
            .catch((error) => {
                alert.show("Ocurrió un error al obtener los datos del Banner", {
                    timeout: 3000,
                    type: "error",
                });
            });
    }

    return (
        <div className="m-2">
            <Carousel
                responsive={responsive}
                renderDotsOutside={true}
                showDots
                infinite
                autoPlay
                autoPlaySpeed={5000}
            >
                {
                    files.map((image, index) => {
                        return <a href={image.link || "#"} target={image.link ? "_blank" : "_self"} rel='noreferrer'>
                            <div key={index} className="text-center">
                                <img src={image.file} alt="" className='img-fluid' />
                            </div>
                        </a>
                    })
                }
            </Carousel>
        </div>
    );
}